import PageView from "@/views/Page.vue";
export const visitorRouter = {
  path: "/visitor",
  redirect: {
    name: "visitorIndex"
  },
  component: PageView,
  children: [
    {
      path: "passCode",
      name: "visitorPassCode",
      component: () => import("@/views/visitor/passCode.vue"),
      meta: {
        title: "通行码"
      }
    },
    {
      path: "faceInfo",
      name: "faceInfo",
      component: () => import("@/views/visitor/faceInfo.vue"),
      meta: {
        title: "人脸信息"
      }
    },
    {
      path: "submitFace",
      name: "submitFace",
      component: () => import("@/views/visitor/submitFace.vue"),
      meta: {
        title: "人脸信息提交"
      }
    }
  ]
};
